import Vue from 'vue'
import App from './App'
import store from './store/store'
import router from './router'
import VueResource from 'vue-resource'
import VueJwtDecode from 'vue-jwt-decode'
import msal from 'vue-msal'
import vuetify from '@/plugins/vuetify'
import './jquery.js'
import 'datatables.net'

import '../static/css/bootstrap.min.css'
import '../static/css/datatables.min.css'
import '../static/css/styles.css'
import '../static/css/toastr.min.css'
import '../static/css/sb-admin-2.min.css'
import '../static/css/fontawesome/css/all.css'
import '../static/css/fontawesome/css/all.min.css'
import '../static/css/fontawesome/css/brands.css'
import '../static/css/fontawesome/css/brands.min.css'
import '../static/css/fontawesome/css/fontawesome.css'
import '../static/css/fontawesome/css/fontawesome.min.css'
import '../static/css/fontawesome/css/regular.css'
import '../static/css/fontawesome/css/regular.min.css'

// Importa los archivos JavaScript
import '../static/js/bootstrap.bundle.min.js'
import '../static/js/datatables.min.js'
import '../static/js/md5.min.js'
import '../static/js/sb-admin-2.min.js'
import '../static/js/toastr.min.js'

const clientId = process.env.VUE_APP_CLIENT_ID
const tenantId = process.env.VUE_APP_TENANT_ID
const redirectUri = process.env.VUE_APP_REDIRECT_URI
const root = process.env.VUE_APP_ROOT
const url = process.env.VUE_APP_URL

Vue.use(msal, {
  auth: {
    clientId: clientId,
    tenantId: tenantId,
    redirectUri: redirectUri
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true
  },
  graph: {
    scopes: ['user.read']
  },
  ssoSilentRenew: {
    auto: true,
    fallbackToRenew: true
  }
})

// Global import
import swal from 'sweetalert'

Vue.config.productionTip = false

Vue.use(VueJwtDecode)
Vue.use(VueResource)

//Vue.http.options.root = 'https://kiin.tecnosis.soevii.io/pri';
//Vue.http.options.url = 'https://kiin.tecnosis.soevii.io/';
Vue.http.options.root = root
Vue.http.options.url = url

const globalEventBus = new Vue({})

new Vue({
  store,
  router,
  vuetify,
  render: (h) => h(App)
}).$mount('#app')
